import { render, staticRenderFns } from "./bank-accounts.vue?vue&type=template&id=440c5050"
import script from "./bank-accounts.vue?vue&type=script&lang=js"
export * from "./bank-accounts.vue?vue&type=script&lang=js"
import style0 from "./bank-accounts.vue?vue&type=style&index=0&id=440c5050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports